<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <wt-readonly-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" >
      </wt-readonly-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'integralAbnormalReportView',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_USERDELIVERYGARBAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userDeliveryGarbage/userDeliveryGarbageUpdate',
      formAddUrl: '/modules/userDeliveryGarbage/userDeliveryGarbageAdd',
      detailFormButtons: {
        title: '投递详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '投递详情',
        className: 'wt-section-long-content',
        elements: [
          { name: '昵称', key: 'nickName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '手机号', key: 'phone', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '社区', key: 'communityName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '获取积分', key: 'integral', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '获取方式',
            key: 'type',
            type: 'select',
            className: 'wt-col-12',
            disabled: true,
            data: [{ label: '全部', value: '' },
              { label: '投递可回收物', value: 1 },
              { label: '后台充值', value: 2 },
              { label: '取消订单返还', value: 3 },
              { label: '异常订单返还', value: 4 },
              { label: '每日任务', value: 5 }] },
          { name: '获取时间', key: 'createTime', type: 'text', className: 'wt-col-12', disabled: true }]
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '投递详情' }})
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.integralAbnormalReport.integralAbnormalReportDetailData
    })
  }
}
</script>

<style scoped>
.detail-img {
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
</style>
